// frontend/src/hooks/useNavigation.js
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { tenantNameToSlug } from '../utils/tenantSlug';

export const useNavigation = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const getTenantPath = (path) => {
    if (!user || !user.tenant_name) {
      return '/login';
    }

    const urlFriendlyTenantName = tenantNameToSlug(user.tenant_name);

    const cleanPath = path.startsWith('/') ? path.slice(1) : path;

    return `/${urlFriendlyTenantName}/${cleanPath}`;
  };

  const navigateToTenant = (path, options) => {
    navigate(getTenantPath(path), options);
  };

  return {
    getTenantPath,
    navigateToTenant,
    navigate // Still expose original navigate for non-tenant routes
  };
};